import styles from "./Error.module.scss";

export const Error = <E,>({ err }: { err: E }): JSX.Element => {
  return <div className={styles.error}>{err}</div>;
};
